import React, { PropsWithChildren } from 'react';
import bem from '../../../../lib/bemUtils/bem';
import { Modifier } from '../../../../lib/bemUtils/Modifier';

export enum RowModifier {
  GRID_3_COLUMNS = 'grid-3-columns',
  GRID_2_COLUMNS = 'grid-2-columns',
  NO_MARGIN = 'no-margin',
  BLOCK = 'block',
  DISPLAY_FLEX = 'display-flex',
  DISPLAY_FLEX_DIRECTION_COLUMN = 'display-flex-direction-column',
  ALIGN_ITEMS_FLEX_END = 'align-items-flex-end',
  GRID_3_COLUMNS_2FR_1FR_3FR = 'grid-3-columns-2fr-1fr-3fr',
}

type Row = PropsWithChildren<{
  modifier?: Modifier<RowModifier>;
}>;

/**
 * The row element creates 2 or more column grid (not CSS Grid) form elements.
 * It's also used to generate the margin-bottom of every form element in one row.
 */
export function Row({ children, modifier }: Row) {
  return <div className={bem('row', modifier)}>{children}</div>;
}
